export enum FileError {
  InvalidType,
  InvalidSize
}